import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { RealityCheckSection } from '../components/RealityCheckSection';
import { SolutionSection } from '../components/SolutionSection';
import { ChaptersSection } from '../components/ChaptersSection';
import { BonusesSection } from '../components/BonusesSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { ClosingSection } from '../components/ClosingSection';
export function LandingPage() {
  return <main className="min-h-screen bg-slate-950 text-slate-200 selection:bg-red-500 selection:text-white" data-id="element-178">
      <HeroSection data-id="element-179" />
      <IdentificationSection data-id="element-180" />
      <RealityCheckSection data-id="element-181" />
      <SolutionSection data-id="element-182" />
      <ChaptersSection data-id="element-183" />
      <BonusesSection data-id="element-184" />
      <ForWhomSection data-id="element-185" />
      <ClosingSection data-id="element-186" />

      <footer className="bg-black py-8 text-center text-slate-600 text-sm" data-id="element-187">
        <div className="container mx-auto px-4" data-id="element-188">
          <p data-id="element-189">
            © 2026 Dominio Total en Free Fire. Todos los derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-190">
            Este producto no está afiliado con Garena Free Fire.
          </p>
        </div>
      </footer>
    </main>;
}